import React from "react";
import { Link } from "@heroui/link";

import { TopProduct } from "../../types/dashboard";

interface TopProductsTableProps {
  products: TopProduct[];
}

const TopProductsTable: React.FC<TopProductsTableProps> = ({ products }) => {
  // Format currency
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(amount / 100); // Assuming amount is in cents
  };

  if (!products || products.length === 0) {
    return (
      <div className="text-center py-6 text-gray-500 dark:text-gray-400">
        No product data available.
      </div>
    );
  }

  return (
    <div className="overflow-hidden">
      <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
        <thead className="bg-gray-50 dark:bg-gray-800">
          <tr>
            <th
              className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              scope="col"
            >
              Product
            </th>
            <th
              className="px-4 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              scope="col"
            >
              Sold
            </th>
            <th
              className="px-4 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              scope="col"
            >
              Revenue
            </th>
          </tr>
        </thead>
        <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
          {products.map((product) => (
            <tr
              key={product.id}
              className="hover:bg-gray-50 dark:hover:bg-gray-900"
            >
              <td className="px-4 py-3 whitespace-nowrap">
                <div className="flex flex-col">
                  <Link
                    className="text-sm font-medium text-gray-900 dark:text-white hover:text-primary-600 dark:hover:text-primary-400"
                    href={`/menu/products/${product.id}`}
                  >
                    {product.name}
                  </Link>
                  <span className="text-xs text-gray-500 dark:text-gray-400">
                    {product.category}
                  </span>
                </div>
              </td>
              <td className="px-4 py-3 whitespace-nowrap text-right text-sm text-gray-900 dark:text-gray-200">
                {product.quantity_sold}
              </td>
              <td className="px-4 py-3 whitespace-nowrap text-right text-sm font-medium text-gray-900 dark:text-gray-200">
                {formatCurrency(product.revenue)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TopProductsTable;
